// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"6cb643a1","955":"308131fb"}[chunkId] + ".chunk.js";
};